export default "__VITE_ASSET__C7Ae_wM___"